import { Button, Col, Row, Spinner} from "react-bootstrap";
import styles from '../../../../../styles/expenditureworksheet.module.css';
import ButtonOverride from "../../../../../components/buttonoverride";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import { Controller, useForm, useWatch } from 'react-hook-form';
import React, { useEffect, useState } from "react";
import ReceiptsPanel from "../receipts/receiptspanel";
import FileUpload from "../../../../../components/fileupload";
import { NumericFormat } from "react-number-format";
import { appendFormData } from "../../../../../utilities/formdata";
import useMessageStore from "../../../../../stores/message-store";
import useApi from "../../../../../hooks/use-api";


const ExpenditureRefundAddEdit = ({ApplicationID,RefundID, returnFunction,refresh,states = [],lineItemCategories = [],checkTypes = [],relatedChecks = [],lexFrankfortAdmins = [],userMasterList = [], readOnly = false }) => {
    const [receivedByList,setReceivedByList] = useState(lexFrankfortAdmins);
    const [releasedToMfpList,setReleasedToMfpList] = useState(lexFrankfortAdmins);
    const [releasedToCopList,SetReleasedToCopList] = useState(lexFrankfortAdmins);
    
    const refundFormValues = {
        receivedbyid: -1,
        receiveddate: '',
        comments: '',
        checknumber: '',
        amount: null,
        from: '',
        relatedto: -1,
        address: '',
        phone: '',
        city: '',
        state: -1,
        zip: '',
        checktypeid: null,
        paytoid: null,
        releasedtomfpadminid: -1,
        releasedtomfpadmindate: '',
        releasedtocopadminid: -1,
        releasedtocopadmindate: ''
    };

    const [prevFiles, setPrevFiles] = useState([]);
    const [newFiles, setNewFiles] = useState([]);
    const [receiptItems, setReceiptItems] = useState([]);
    
    //Used for tracking to enable or disable submit button if something has changed
    const [initialPrevFiles,setInitialPrevFiles] = useState([]);
    const [initialLineItems,setInitialLineItems] = useState([]);
    
    const [isLoading,setIsLoading] = useState(() => RefundID ? true : false); //Initalize state based on procardId being supplied

    const { register, handleSubmit,control, reset,watch, formState: { isSubmitting,isDirty } } = useForm({
        defaultValues: refundFormValues
    });

    const addToast = useMessageStore(state => state.addToast);

    const submit = async(data) => {
        const sendObject = {
            ...data,
            lineitems: receiptItems,
            existingfiles: prevFiles,
            applicationid: ApplicationID,
            refundid: RefundID
        }

        const formData = new FormData();

        appendFormData(formData,sendObject);
        
        for (let index = 0; index < newFiles.length; index++) {
            const element = newFiles[index].file;
        
            formData.append(`newfiles`, element);
        }

        if(!RefundID){
            const [data,status] = await postFileRequest('ExpenditureWorksheet_Refund_Add',formData);

            if(status === 201){
                addToast({
                    id: Math.random(),
                    body: 'Refund added successfully!',
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                })
                
                refresh();
                returnFunction();
            }
            else{
                addToast({
                    id: Math.random(),
                    body: 'An error occured when adding the Refund.',
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                })
            }
        }
        else{
            const [data,status] = await putFileRequest('ExpenditureWorksheet_Refund_Update',formData);

            if(status === 200){
                setNewFiles([]);

                const {existingfiles,lineitems,...dataValues} = data;

                setPrevFiles(existingfiles);
                setReceiptItems(lineitems);

                setInitialLineItems(lineitems);
                setInitialPrevFiles(existingfiles);

                if(dataValues.receivedbyid === null){
                    dataValues.receivedbyid = refundFormValues.receivedbyid;
                }

                if(dataValues.releasedtomfpadminid === null){
                    dataValues.releasedtomfpadminid = refundFormValues.releasedtomfpadminid;
                }

                if(dataValues.releasedtocopadminid === null){
                    dataValues.releasedtocopadminid = refundFormValues.releasedtocopadminid;
                }

                reset(dataValues);

                addToast({
                    id: Math.random(),
                    body: 'Refund updated successfully!',
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                })
            }
            else{
                addToast({
                    id: Math.random(),
                    body: 'An error occured when updating the Refund.',
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                })
            }

            refresh();

        }

    };

    const {getRequest,postFileRequest,putFileRequest} = useApi();

    const get = async() => {
        const [data,status] = await getRequest('ExpenditureWorksheet_Refund_Get',{refundid : RefundID,timestamp: new Date()});
    
        setIsLoading(false);
        if(status === 200){
            const {existingfiles,lineitems,...dataValues} = data;

            if(dataValues.receivedbyid !== null){
                if(!lexFrankfortAdmins.find(item => item.id === dataValues.receivedbyid)){
                    const masterRef = userMasterList.find(item => item.id === dataValues.receivedbyid);
                    const inactiveItem = {
                        ...masterRef,
                        Inactive: true
                    }
                    
                    setReceivedByList([inactiveItem,...lexFrankfortAdmins]);
                }
            }
            else{
                dataValues.receivedbyid = -1;
            }
            
            if(dataValues.releasedtomfpadminid !== null){
                if(!lexFrankfortAdmins.find(item => item.id === dataValues.releasedtomfpadminid)){
                    const masterRef = userMasterList.find(item => item.id === dataValues.releasedtomfpadminid);
                    const inactiveItem = {
                        ...masterRef,
                        Inactive: true
                    }
                    
                    setReleasedToMfpList([inactiveItem,...lexFrankfortAdmins]);
                }
            }
            else{
                dataValues.releasedtomfpadminid = -1;
            }

            if(dataValues.releasedtocopadminid !== null){
                if(!lexFrankfortAdmins.find(item => item.id === dataValues.releasedtocopadminid)){
                    const masterRef = userMasterList.find(item => item.id === dataValues.releasedtocopadminid);
                    const inactiveItem = {
                        ...masterRef,
                        Inactive: true
                    }
                    
                    SetReleasedToCopList([inactiveItem,...lexFrankfortAdmins]);
                }
            }
            else{
                dataValues.releasedtocopadminid = -1;
            }
    
            setPrevFiles(existingfiles);
            setReceiptItems(lineitems);
    
            setInitialLineItems(lineitems);
            setInitialPrevFiles(existingfiles);
    
            reset(dataValues);
        }
        else{
            //Handle error gracefully
        }
    
    }
    
    useEffect(() => {
        if(RefundID){
            get();
        }
        else{
            setPrevFiles([]);
            setReceiptItems([]);
            setNewFiles([]);
        }
    
    }, [])

    const amount = watch('amount');
    const receivedbyid = watch('receivedbyid');
    const releasedtomfpadminid = watch('releasedtomfpadminid');
    const releasedtocopadminid = watch('releasedtocopadminid');

    const existingFilesChanged = prevFiles.length !== initialPrevFiles.length;
    const existingLineItemsChanged = JSON.stringify(receiptItems) !== JSON.stringify(initialLineItems);
    const mismatchLineItemsAndAmount = !(amount === null && receiptItems.length === 0) ? amount !== receiptItems.reduce((sum,current) => sum + current.amount,0) : false;

    const receivedbyError = receivedbyid > 0
    ? 
        receivedByList.find(item => item.id === receivedbyid).Inactive 
    : 
        false;

    const releasedToMfpError = releasedtomfpadminid > 0
    ? 
        releasedToMfpList.find(item => item.id === releasedtomfpadminid).Inactive 
    : 
        false;

    const releasedToCopError = releasedtocopadminid > 0
    ? 
        releasedToCopList.find(item => item.id === releasedtocopadminid).Inactive 
    : 
        false;


    if(isLoading){
        return(
            <div>loading...</div>
        )
    }

    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="clientCard">
                <div className="clientCardInner">
                    <div className={styles.expenditureSubNavContainer}>
                        <ButtonOverride type="button" className={styles.expenditureSubNavBackButton} aria-label="Return" onClick={returnFunction}>
                            <FontAwesomeIcon icon={faCircleArrowLeft} size="2xl" />
                        </ButtonOverride>
                        <h5 className={styles.expenditureSubNavTitle}>
                            {RefundID === null ? <>Add Refund</> : readOnly ? <>View Refund #{RefundID}</> : <>Edit Refund #{RefundID}</>}
                        </h5>
                    </div>
                    <div className={`${styles.addEditForm} mt-4`}>
                        <Row>
                            <Col xs={12} md={6}>
                                <strong className="d-flex justify-content-center">
                                    Record Refund Check Receipt Section
                                </strong>
                                <Row>
                                    <Col xs={12} md={8}>
                                        <label htmlFor="receivedbyid">Received By</label>
                                        <Controller
                                            name="receivedbyid"
                                            control={control}
                                            render={({field}) => (
                                                <select {...field} style={{width: '100%',height: '30px',color: receivedbyError ? 'red' : 'black'}} id="receivedbyid" onChange={(e) => {
                                                    field.onChange(parseInt(e.target.value,10))
                                                }}>
                                                <option value={-1} style={{color: 'black'}}>--Select User--</option>
                                                {
                                                    receivedByList.map((user) => (
                                                        <option key={user.id} value={user.id} style={{color: user.Inactive ? 'red' : 'black'}} disabled={user.Inactive ? true : false}>{user.name} {user.Inactive ? <>-- No Longer Active</> : null}</option>
                                                    ))
                                                }
                                                </select>
                                            )}
                                        />
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <label htmlFor="receiveddate" >Date Received</label>
                                        <input type="date" id="receiveddate" {...register('receiveddate')} style={{ width: '100%' }} />
                                    </Col>
                                    <Col xs={12}>
                                        <label htmlFor="comments">Comments</label>
                                        <textarea id="comments" {...register('comments')} rows={4} style={{ width: '100%' }} />
                                    </Col>
                                </Row>
                                <strong className="d-flex justify-content-center">
                                    Record Refund Check Release Section
                                </strong>
                                <Row>
                                    <Col xs={12} md={8}>
                                        <label htmlFor="releasedtomfpadminid">Released To MFP Admin</label>
                                        <Controller
                                            name="releasedtomfpadminid"
                                            control={control}
                                            render={({field}) => (
                                                <select {...field} style={{width: '100%',height: '30px',color: releasedToMfpError ? 'red' : 'black'}} id="releasedtomfpadminid" onChange={(e) => {
                                                    field.onChange(parseInt(e.target.value,10))
                                                }}>
                                                <option value={-1} style={{color: 'black'}}>--Select User--</option>
                                                {
                                                    releasedToMfpList.map((mfpadmin) => (
                                                        <option key={mfpadmin.id} value={mfpadmin.id} style={{color: mfpadmin.Inactive ? 'red' : 'black'}} disabled={mfpadmin.Inactive ? true : false}>{mfpadmin.name} {mfpadmin.Inactive ? <>-- No Longer Active</> : null}</option>
                                                    ))
                                                }
                                                </select>
                                            )}
                                        />
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <label htmlFor="releasedtomfpadmindate" >Date Released</label>
                                        <input type="date" id="releasedtomfpadmindate" {...register('releasedtomfpadmindate')} style={{ width: '100%' }} />
                                    </Col>
                                    <Col xs={12} md={8}>
                                        <label htmlFor="releasedtocopadminid">Released To COP Admin</label>
                                        <Controller
                                            name="releasedtocopadminid"
                                            control={control}
                                            render={({field}) => (
                                                <select {...field} style={{width: '100%',height: '30px',color: releasedToCopError ? 'red' : 'black'}} id="releasedtocopadminid" onChange={(e) => {
                                                    field.onChange(parseInt(e.target.value,10))
                                                }}>
                                                <option value={-1} style={{color: 'black'}}>--Select User--</option>
                                                {
                                                    releasedToCopList.map((copadmin) => (
                                                        <option key={copadmin.id} value={copadmin.id} style={{color: copadmin.Inactive ? 'red' : 'black'}} disabled={copadmin.Inactive ? true : false}>{copadmin.name} {copadmin.Inactive ? <>-- No Longer Active</> : null}</option>
                                                    ))
                                                }
                                                </select>
                                            )}
                                        />
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <label htmlFor="releasedtocopadmindate" >Date Released</label>
                                        <input type="date" id="releasedtocopadmindate" {...register('releasedtocopadmindate')} style={{ width: '100%' }} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className={styles.formBox}>
                                    <strong className="d-flex justify-content-center">Check Information</strong>
                                    <Row>
                                        <Col xs={12} md={8}>
                                            <label htmlFor="checknumber" >Check Number</label>
                                            <input id="checknumber" type="text" {...register('checknumber')} style={{ width: '100%' }} />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="amount">Amount</label>
                                            <Controller
                                                name="amount"
                                                control={control}
                                                render={({ field }) => (
                                                    <NumericFormat 
                                                        value={field.value} 
                                                        id="amount" 
                                                        placeholder="Amount" 
                                                        style={{ width: '100%', height: '30px' }} 
                                                        prefix={'$'} 
                                                        decimalScale={2} 
                                                        fixedDecimalScale={true} 
                                                        allowNegative={false}
                                                        onValueChange={(values) => {
                                                            if(values.floatValue === undefined || values.floatValue === null){
                                                                field.onChange(refundFormValues.amount); //Reset to default
                                                            }
                                                            else{
                                                                field.onChange(values.floatValue);
                                                            }
                                                        }} 
                                                    />
                                                )}
                                            />
                                        </Col>
                                        <Col xs={12} md={8}>
                                            <label htmlFor="from">From</label>
                                            <input type="text" id="from" style={{width: '100%'}} {...register('from')}/>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="relatedto">Related To</label>
                                            <Controller
                                                name="relatedto"
                                                control={control}
                                                render={({field}) => (
                                                    <select {...field} style={{width: '100%',height: '30px'}} id="relatedto" onChange={(e) => {
                                                        field.onChange(parseInt(e.target.value,10))
                                                    }}>
                                                    <option value={-1}>--Select Check--</option>
                                                    {
                                                        relatedChecks.map((check) => (
                                                            <option key={check.id} value={check.id}>{check.detail}</option>
                                                        ))
                                                    }
                                                    </select>
                                                )}
                                            />
                                        </Col>
                                        <Col xs={12} md={8}>
                                            <label htmlFor="address">Address</label>
                                            <input type="text" id="address" style={{width: '100%'}} {...register('address')}/>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="phone">Phone</label>
                                            <input type="text" id="phone" style={{width: '100%'}} {...register('phone')}/>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="city">City</label>
                                            <input type="text" id="city" style={{width: '100%'}} {...register('city')}/>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="state">State</label>
                                            <Controller
                                                name="state"
                                                control={control}
                                                render={({field}) => (
                                                <select {...field} style={{width: '100%',height: '30px'}} id="state" onChange={(e) => {
                                                            field.onChange(parseInt(e.target.value,10))
                                                        }}>
                                                            <option value={-1}>--Select State--</option>
                                                            {
                                                                states.map((state) => (
                                                                    <option key={state.id} value={state.id}>{state.name}</option>
                                                                ))
                                                            }
                                                </select>
                                                )}
                                            />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="zip">Zip</label>
                                            <input type="text" id="zip" style={{width: '100%'}} {...register('zip')}/>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <strong>Check Type</strong>
                                            {
                                                checkTypes.map((ct) =>
                                                <div key={ct.id}>
                                                    <label>
                                                        <input type="radio" {...register('checktypeid')} value={ct.id} />
                                                        {ct.name}
                                                    </label>
                                                </div>)
                                            }
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <strong>Pay To</strong>
                                            {
                                                checkTypes.map((ct) =>
                                                <div key={ct.id}>
                                                    <label>
                                                        <input type="radio" {...register('paytoid')} value={ct.id} />
                                                        {ct.name}
                                                    </label>
                                                </div>)
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <div style={{borderTop: '1px solid black',marginTop: '1rem',marginBottom: '1rem'}}></div>
                        <Row className="mt-4 mb-2">
                            <Col xs={12}>
                                <ReceiptsPanel fields={receiptItems} setField={setReceiptItems} lineItemCategories={lineItemCategories} readOnly={readOnly}/>
                            </Col>
                            <Col xs={12}>
                                <FileUpload
                                    title="Supporting Documents"
                                    previousFiles={prevFiles} 
                                    newFiles={newFiles} 
                                    setNewFiles={setNewFiles} 
                                    setPrevFiles={setPrevFiles}
                                    FileDownloadData={{RefundID: RefundID}}
                                    prevFileDownloadEndpointKey="ExpenditureWorksheet_Refund_FileDownload" 
                                    readOnly={readOnly}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-between align-items-end mt-2">
                        <Button type="button" variant={readOnly ? "secondary" : "danger"} onClick={returnFunction} disabled={isSubmitting}>{readOnly ? "Return" : "Cancel"}</Button>
                        {
                            !readOnly
                            ?
                                <Button type="submit" variant={RefundID !== null ? 'primary' : 'success'}  disabled={isSubmitting || (!isDirty && !newFiles.length > 0 && !existingFilesChanged && !existingLineItemsChanged)}>
                                    {
                                        !isSubmitting
                                        ?
                                            RefundID
                                            ?
                                                <>
                                                    <FontAwesomeIcon icon={faSave} size="xl" className="me-1" />
                                                    Save Changes
                                                </>
                                            :
                                                <>
                                                    <FontAwesomeIcon icon={faPlus} size="xl" className="me-1" />
                                                    Add Refund
                                                </>
                                        :
                                            <Spinner animation='border' size='sm' />
                                    }
                                </Button>
                            :
                                null
                        }
                    </div>
                </div>
            </div>
        </form>
    )

};


export default ExpenditureRefundAddEdit;
